export default __webpack_public_path__ + "files/ico-send.png";